// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQNNR","title":"styles_title__3McnO"};